import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import { Box, Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import { Nullable } from "store/types";
import { BaseModal } from "store/types/modals";

import { useModals } from "../../../hooks";

const modalPositionSx = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none"
};

const opacityAppearanceKeyframes = {
  "@keyframes opacityOpen": {
    "0%": { opacity: 0 },
    "100%": { opacity: 1 }
  }
};

export const ErrorModal: React.FC<{ data: Nullable<BaseModal> }> = ({ data }) => {
  const { closeErrorModal } = useModals();
  return (
    <Modal open={!!data} onClose={closeErrorModal}>
      <Box sx={modalPositionSx}>
        <Box
          sx={{
            ...opacityAppearanceKeyframes,
            minWidth: 550,
            maxWidth: 600,
            animation: "opacityOpen 0.3s forwards"
          }}
        >
          <Stack
            sx={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              height: 50,
              backgroundColor: "#e74c3c",
              borderRadius: "10px 10px 0 0",
              padding: "0 12px 0 20px",
              color: "#ffffff",
              fontSize: 18
            }}
          >
            <Stack sx={{ flexDirection: "row", alignItems: "center", spacing: 1.25, gap: "10px" }}>
              <ErrorIcon />
              <Typography component="span" sx={{ fontSize: 18, color: "inherit" }}>
                {data?.title || "ERROR"}
              </Typography>
            </Stack>
            <IconButton onClick={closeErrorModal} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <Stack
            sx={{
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "flex-end",
              minHeight: 150,
              maxHeight: 250,
              backgroundColor: "#ffffff",
              borderRadius: "0 0 10px 10px",
              p: "16px 20px 20px 20px"
            }}
          >
            <Box sx={{ overflow: "auto", alignSelf: "stretch" }}>
              <Typography
                sx={{
                  color: "#0a3243",
                  fontSize: 18,
                  alignSelf: "flex-start",
                  lineHeight: 1.6,
                  whiteSpace: "break-spaces"
                }}
              >
                {data?.msg}
              </Typography>
            </Box>
            <Button onClick={closeErrorModal} variant="outlined">
              Ok
            </Button>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};
